// lightTheme.js
import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    type: 'light', // Set the theme type to light
    primary: {
      main: '#1976D2', // Adjust the primary color as needed
    },
    secondary: {
      main: '#FF4081', // Adjust the secondary color as needed
    },
    error: {
      main: '#F44336', // Adjust the error color as needed
    },
    warning: {
      main: '#FFC107', // Adjust the warning color as needed
    },
    info: {
      main: '#2196F3', // Adjust the info color as needed
    },
    success: {
      main: '#4CAF50', // Adjust the success color as needed
    },
    background: {
      default: '#FFFFFF', // Set the default background color to white
    },
  },
});

export default lightTheme;
